import { lazyLoad } from '~/src/shared/utils/loadable';

export const MunicipalityCollaborationShizuokaPage = lazyLoad(
  () => import('./index'),
  (module) => module.MunicipalityCollaborationShizuoka,
);
